import { TransformerPhase } from "../constants/phase";
import { CommittedLoad } from "../model/viewModel/committedLoad";
import { GroupedConnectionPoint } from "../model/viewModel/groupedConnectionPoint";
import { LatLng } from "../model/viewModel/simpleTypes";
import {
  TransformerMounting,
  TransformerProperties,
} from "../model/viewModel/transformerProperties";

export const getTransformerProperties = (
  nameplateRating: number,
  nameplateRatingIsDefault: boolean,
  cyclicRating: number,
  mounting: TransformerMounting,
  geometry: LatLng,
  systemVoltage: number,
  numberOfPhases: TransformerPhase,
  numberOfPhasesIsDefault: boolean,
  fuseSelection: string,
  fuseSelectionIsDefault: boolean,
  fuseRating: number,
  autoSelect: boolean,
  groupedConnectionPoints: GroupedConnectionPoint[],
  hvFaultLevel: number,
  hvFaultLevelIsDefault: boolean,
  xrRatio: number,
  annotation: string,
  xrRatioIsDefault: boolean,
  ohEnvironment: string,
  poleTermLength: number,
  isDefaultPoleTermLength: boolean,
  designVoltage: number,
  committedLoad: CommittedLoad,
  primaryVoltagekV: number,
  primaryVoltagekVIsDefault: boolean,
) => {
  let transformerProperties: TransformerProperties = new TransformerProperties();
  transformerProperties.nameplateRating = nameplateRating;
  transformerProperties.nameplateRatingIsDefault = nameplateRatingIsDefault;
  transformerProperties.cyclicRating = cyclicRating;
  transformerProperties.mounting = mounting;
  transformerProperties.geometry = geometry;
  transformerProperties.systemVoltage = systemVoltage;
  transformerProperties.numberOfPhases = numberOfPhases;
  transformerProperties.numberOfPhasesIsDefault = numberOfPhasesIsDefault;
  transformerProperties.fuseSelection = fuseSelection;
  transformerProperties.fuseSelectionIsDefault = fuseSelectionIsDefault;
  transformerProperties.fuseRating = fuseRating;
  transformerProperties.autoSelect = autoSelect;
  transformerProperties.groupedConnectionPoints = (groupedConnectionPoints ?? []).map((p) => ({
    ...p,
    subGroupConnectionPoints: [...(p.subGroupConnectionPoints ?? [])],
  }));
  transformerProperties.hvFaultLevel = hvFaultLevel;
  transformerProperties.hvFaultLevelIsDefault = hvFaultLevelIsDefault;
  transformerProperties.xrRatio = xrRatio;
  transformerProperties.annotation = annotation;
  transformerProperties.xrRatioIsDefault = xrRatioIsDefault;
  transformerProperties.ohEnvironment = ohEnvironment;
  transformerProperties.poleTermLength = poleTermLength;
  transformerProperties.isDefaultPoleTermLength = isDefaultPoleTermLength;
  transformerProperties.designVoltage = designVoltage;
  transformerProperties.committedLoad = committedLoad;
  transformerProperties.primaryVoltagekV = primaryVoltagekV;
  transformerProperties.primaryVoltagekVIsDefault = primaryVoltagekVIsDefault;
  return transformerProperties;
};
